// extracted by mini-css-extract-plugin
module.exports = {"login__header":"styles_login__header__BSC_3","login__error":"styles_login__error__9EYJN"};